import {HiOutlineGlobeAlt} from "react-icons/hi";
import {Tag} from "../types";
import React from "react";
import ResearchPills from "./ResearchPills";

interface ResearchSectionProps {
  stableKey: string;
  tag: Tag;
}

const ResearchSection: React.FC<ResearchSectionProps> = ({ stableKey, tag }) => {
  return (
    <div key={stableKey} className="research-section timeline-node">
      <div className="research-header">
        <div className="research-title">
          <HiOutlineGlobeAlt className="w-3 h-3" />
          <span>{tag.text || 'Web Search'}</span>
          {tag.isStreaming && (
            <div className="thinking-dots">
              <div className="thinking-dot" />
              <div className="thinking-dot" />
              <div className="thinking-dot" />
            </div>
          )}
        </div>
      </div>
      
      <div className="research-content">
        {/* {tag.text && (
          <div className="text-[12px] text-gray-500 dark:text-gray-500 mb-4">{tag.text}</div>
        )} */}
        <ResearchPills tag={tag} />
        {tag.isStreaming && <span className="thinking-cursor" />}
      </div>
    </div>
  );
}

export default ResearchSection;